import { useAppDispatch } from "@/services/store";
import type { UseFilters } from "@/features/notes-manager";
import type { MenuSorterOptions } from "@/common/AppHeader/mobile/Components/Menu/MenuSorterList";
import { commitmentsPageActions } from "../slice";

export const useFilters = (): UseFilters => {
  const dispatch = useAppDispatch();

  const setSorter = (sort: MenuSorterOptions) => {
    dispatch(commitmentsPageActions.setSorter(sort));
  };

  const setTitleFilter = (value: string) => {
    dispatch(commitmentsPageActions.setTitleFilter(value));
  };

  const setNoteTitleFilter = (value: string) => {
    dispatch(commitmentsPageActions.setNoteTitleFilter(value));
  };

  const setFromDateFilter = (value: string) => {
    dispatch(commitmentsPageActions.setFromDateFilter(value));
  };

  const setToDateFilter = (value: string) => {
    dispatch(commitmentsPageActions.setToDateFilter(value));
  };

  const setPersonGroupFilters = (value: string[]) => {
    dispatch(commitmentsPageActions.setPersonGroupFilters(value));
  };

  const setNoteTypeFilters = (value: string[]) => {
    dispatch(commitmentsPageActions.setNoteTypeFilters(value));
  };

  const setStringFilter = (value: string) => {
    dispatch(commitmentsPageActions.setStringFilter(value));
  };

  const setStatusFilters = (value: string[]) => {
    dispatch(commitmentsPageActions.setStatusFilter(value));
  };

  const setDirectionFilters = (value: string[]) => {
    dispatch(commitmentsPageActions.setDirectionFilters(value));
  };

  const setFromDueDateFilter = (value: string) => {
    dispatch(commitmentsPageActions.setFromDueDateFilter(value));
  };

  const setToDueDateFilter = (value: string) => {
    dispatch(commitmentsPageActions.setToDueDateFilter(value));
  };

  return {
    setSorter,
    setTitleFilter,
    setNoteTitleFilter,
    setFromDateFilter,
    setToDateFilter,
    setPersonGroupFilters,
    setNoteTypeFilters,
    setStringFilter,
    setStatusFilters,
    setDirectionFilters,
    setFromDueDateFilter,
    setToDueDateFilter,
  };
};
